(function(){
  const endsAt = (document.getElementById('ends_at')||{}).textContent?.trim();
  const code = (document.getElementById('code_val')||{}).textContent?.trim();
  const cd = document.getElementById('countdown');
  const btn = document.getElementById('copy_button');
  const wrap = document.getElementById('button_div');

  function tick(){
    if(!endsAt){ if(cd) cd.textContent=''; return; }
    const end = new Date(endsAt); const now = new Date();
    if (isNaN(end)) { if(cd) cd.textContent=''; return; }
    if (end <= now) { if(cd) cd.textContent = 'Abgelaufen'; return; }
    const diff = Math.floor((end - now)/1000);
    const d = Math.floor(diff/86400), h = Math.floor((diff%86400)/3600), m = Math.floor((diff%3600)/60);
    if(cd) cd.textContent = `Noch ${d} Tage ${h} Std ${m} Min`;
  }
  tick(); setInterval(tick, 60000);

  if (btn) btn.addEventListener('click', function(){
    if(!code) return;
    navigator.clipboard.writeText(code).then(()=>{
      if(wrap){ wrap.classList.add('active'); setTimeout(()=>wrap.classList.remove('active'), 1500); }
    }).catch(console.error);
  });
})();